import Modal from "../../../../global/Modal";
import { STRINGS } from "../../utils/string";

import AddEditModal from "./AddEditModal/AddEditModal";
import FailureModal from "./FailureModal";
import SuccessModal from "./SuccessModal";
import WarningModal from "./WarningModal";

export default function Modals({
  modalMode = "",
  modalSize = "md",
  additionalDetails = {},
  open,
  onClose,
}) {
  function getModal() {
    switch (modalMode) {
      case STRINGS.MODAL_MODE.ADD:
        return <AddEditModal mode={modalMode} additionalDetails={additionalDetails} />;
      case STRINGS.MODAL_MODE.EDIT:
        return <AddEditModal mode={modalMode} additionalDetails={additionalDetails} />;
      case STRINGS.MODAL_MODE.DELETE:
        return <WarningModal additionalDetails={additionalDetails} />;
      case STRINGS.MODAL_MODE.SUCCESS:
        return <SuccessModal additionalDetails={additionalDetails} />;
      case STRINGS.MODAL_MODE.FAILURE:
        return <FailureModal additionalDetails={additionalDetails} />;
      default:
        return null;
    }
  }

  return (
    <Modal open={open} onClose={onClose} maxWidth={modalSize}>
      <div className="flex flex-row items-center justify-center p-2">{getModal()}</div>
    </Modal>
  );
}
